export const LANGUAGES = [
  {
    cultureCode: 'en-US',
    name: 'English'
  },
  // {
  //   cultureCode: 'de-DE',
  //   name: 'German'
  // }
];